var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticStyle: { height: "100vh" }, attrs: { direction: "vertical" } },
    [
      _c("publicHeader"),
      _c("el-main", [
        _c("div", { staticClass: "error500" }, [
          _c("h1", [_vm._v("500")]),
          _c("h2", [_vm._v("Internal Server Error")]),
          _c("p", [
            _vm._v(
              "Current page can't be displayed due to trouble of programs or server."
            ),
            _c("br"),
            _vm._v("We are sorry for the inconvenience."),
          ]),
        ]),
      ]),
      _c("publicFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }